import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import Heading from '@cotyorg/ccx-atoms/Heading';
import Link from '@cotyorg/ccx-atoms/Link';
import { isSmallBreakpoint } from '../../utils';
import ProductRetailers from '../ProductRetailers';
import ProductSelection from '../ProductSelection';
import ProductSteps from '../ProductSteps';

const ProductInfo = ({
  sectionHeadings,
  productDetails,
  currentBreakpoint,
  subcategoryTitle,
  categoryTitle,
  productSwatch,
  useBazaarvoice,
  shouldShowRetailers,
  locale,
  hidePrice,
}) => (
  <div className="product-info flex-container flex-dir-column">
    {!isSmallBreakpoint({ currentBreakpoint }) && (
      <>
        <Heading
          data-test="product-heading"
          extraClass="h2 product-info__heading"
          level={1}
          itemProp="name"
        >
          {R.path(['productDetails', 'heading'], sectionHeadings)}
        </Heading>

        <div
          data-test="product-description"
          className="product-info__description"
        >
          {R.prop('description', productDetails)}
        </div>
        <ProductSteps />
      </>
    )}

    <ProductSelection
      productDetails={productDetails}
      subcategoryTitle={subcategoryTitle}
    />

    {useBazaarvoice && (
      <div className="product-info__rating flex-container align-center">
        <div className="product-info__rating-summary-container">
          <div
            data-bv-show="rating_summary"
            data-bv-product-id={R.prop('bvid', productDetails)}
          />
        </div>

        <div className="product-info__rating__link">
          {
            R.prop('numberOfReviews', productDetails) > 0 ? (
              /* eslint-disable jsx-a11y/anchor-is-valid */
              <Link anchor="#reviews">
                {R.prop('readReviewsLabel', productDetails)}
              </Link>
            ) : (
              <Link anchor="#reviews">
                {R.prop('noReviewsLabel', productDetails)}
              </Link>
            )
            /* eslint-enable jsx-a11y/anchor-is-valid */
          }
        </div>
      </div>
    )}

    {isSmallBreakpoint({ currentBreakpoint }) && (
      <>
        <div className="product-info__description">
          {R.prop('description', productDetails)}
        </div>

        <ProductSteps />
      </>
    )}

    <ProductRetailers
      sectionHeadings={sectionHeadings}
      productTitle={R.prop('title', productDetails)}
      categoryTitle={categoryTitle}
      subcategoryTitle={subcategoryTitle}
      productSwatch={productSwatch}
      locale={locale}
      hidePrice={hidePrice}
    />
  </div>
);

ProductInfo.propTypes = {
  sectionHeadings: PropTypes.shape({
    relatedProducts: PropTypes.shape({
      heading: PropTypes.string,
    }),
    howToSteps: PropTypes.shape({
      heading: PropTypes.string,
    }),
    retailers: PropTypes.shape({
      heading: PropTypes.string,
    }),
  }),
  productDetails: PropTypes.shape({
    averageRating: PropTypes.any,
    benefits: PropTypes.arrayOf(PropTypes.any),
    buyButtonLabel: PropTypes.string,
    bvid: PropTypes.string,
    description: PropTypes.string,
    howToSteps: PropTypes.arrayOf(PropTypes.any),
    showIngredients: PropTypes.string,
    hideIngredients: PropTypes.string,
    longDescription: PropTypes.string,
    outOfStockLabel: PropTypes.string,
    priceRetailersPluralLabel: PropTypes.string,
    priceRetailersSingularLabel: PropTypes.string,
    retailersNotFoundLabel: PropTypes.string,
    shadeSelectLabel: PropTypes.string,
    title: PropTypes.string,
  }),
  currentBreakpoint: PropTypes.string,
  subcategoryTitle: PropTypes.string,
  categoryTitle: PropTypes.string,
  productSwatch: PropTypes.shape({
    swatches: PropTypes.arrayOf(
      PropTypes.shape({
        sku: PropTypes.string,
        itemName: PropTypes.string,
        skuColor: PropTypes.string,
      })
    ),
  }),
  useBazaarvoice: PropTypes.bool,
  shouldShowRetailers: PropTypes.bool,
  locale: PropTypes.string,
  hidePrice: PropTypes.bool,
};

export default ProductInfo;
